








import { Component, Vue } from "vue-property-decorator";
import FormularioEsterilizacion from "@/components/Formularios/FormularioEsterilizacion.vue";

@Component({
  components: {
    FormularioEsterilizacion
  },
  meta: {
    title:
      "Formulario de inscripción esterilización canina y felina - Ilustre Municipalidad de Punta Arenas",
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class CarnavalView extends Vue {
  private mounted() {
    document.title =
      "Formulario de inscripción esterilización canina y felina - Ilustre Municipalidad de Punta Arenas";
  }
}
